import desktopImg from '@/public/images/onboarding/desktop-step-3.jpg'
import classNames from 'classnames'
import { Button } from 'components/common/Button'
import { RadioGroup } from 'components/common/RadioGroup'
import { OnboardingScreen } from 'components/onboarding/OnboardingScreen'
import {
  OnboardingScreenHeader,
  OnboardingScreenTitles,
} from 'components/onboarding/OnboardingScreenHeader'
import { ONBOARDING_EXPERIENCE } from 'constants/onboarding'
import { useOnboarding } from 'contexts/hooks/useOnboarding'
import { useUserProfile } from 'hooks'
import { useUpdateOnboarding } from 'hooks/onboarding/useUpdateOnboarding'
import useTranslation from 'next-translate/useTranslation'
import { useState } from 'react'

export function ArtPurchasingHistory() {
  const { t } = useTranslation('onboarding')
  const { next } = useOnboarding()
  const { data: userProfile } = useUserProfile()
  const [value, setValue] = useState(userProfile?.onboarding?.experience || '')

  const { mutate: update, isLoading } = useUpdateOnboarding()

  function onAction() {
    if (!value) return

    update(
      { experience: value },
      {
        onSuccess() {
          next()
        },
      }
    )
  }

  return (
    <OnboardingScreen desktopImg={desktopImg}>
      <OnboardingScreenHeader step={2}>
        <OnboardingScreenTitles
          title={t('art_purchasing_history.title')}
          className='hidden sm:block'
        />
      </OnboardingScreenHeader>

      <div className='py-6 px-8 pb-10 sm:pb-6 h-full flex flex-col justify-between bg-warm-50'>
        <div
          className={classNames(
            'flex flex-col flex-1 justify-center transition-opacity duration-150',
            isLoading && 'opacity-50'
          )}
        >
          <OnboardingScreenTitles
            title={t('art_purchasing_history.title')}
            className='sm:hidden mb-8'
          />

          <RadioGroup
            value={value}
            onValueChange={setValue}
            items={[
              {
                label: t('art_purchasing_history.no_just_starting_out'),
                value: ONBOARDING_EXPERIENCE.NEW,
              },
              {
                label: t('art_purchasing_history.yes_collected_few_artworks'),
                value: ONBOARDING_EXPERIENCE.INTERMEDIATE,
              },
              {
                label: t('art_purchasing_history.yes_experienced_collector'),
                value: ONBOARDING_EXPERIENCE.EXPERIENCED,
              },
            ]}
          />
        </div>

        <div>
          <div className='sm:hidden w-full'>
            <Button
              style='solid-primary'
              pill
              size='lg'
              className='w-full'
              onClick={onAction}
              disabled={!value || isLoading}
              isLoading={isLoading}
            >
              {t('art_purchasing_history.action')}
            </Button>
          </div>
          <div className='hidden sm:block w-full'>
            <Button
              style='solid-primary'
              pill
              size='md'
              className='w-full'
              onClick={onAction}
              disabled={!value || isLoading}
              isLoading={isLoading}
            >
              {t('art_purchasing_history.action')}
            </Button>
          </div>
        </div>
      </div>
    </OnboardingScreen>
  )
}
